import React, { useReducer, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep';

import ActionButton, { SquaredButton } from '../../components/builder/ActionButton';
import ActionLink from '../../components/builder/ActionLink';
import ButtonCollection from '../../components/builder/ButtonCollection';
import ToggleButton from './ToggleButton';
import BuilderSubSectionTitle from '../backend/BuilderSubSectionTitle';

export const openAction = {
	squared:true,
	onClick:(props) => props.dispatch({ type:'SETOPEN', id:props.field.id }),
	_class:(props) => ({icon:((props.field.id == props.open) ? 'knk-hide' : 'knk-unhide')})
};

const Item = (props) => {
	const field = props.field;
	const isOpen = (field.id === props.open) ? true : false;

	const change = (k, v, loc) => {
		props.dispatch({ type:'CHANGE_VALUE', id:field.id, k, v, loc });
	};

	const changeMulti = (data) => {
		props.dispatch({ type:'CHANGE_MULTI', id:field.id, data });
	}
	
	let title = (isNotEmpty(field, 'short_title')) ? field.short_title : field.title;
	if(props.fields[0].title != undefined) {
		title = props.fields[0].title(field);
	}

	const thumb_image = (isNotEmpty(field, 'image')) ? field.full_image : false;
	const icon = 'without_icon';

	const open = () => {
		if((props?.actions ?? []).length == 0) return;
		props.dispatch({ type:'SETOPEN', id:field.id });
	};

	const improvedOpen = (field) => {
		if(props.onOpen != undefined) props.onOpen(field);
		props.dispatch({ type:'SETOPEN', id:field.id });
	};

	return (
		<li
			key={field.id}
			class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center"
			style={field.style}
		>
			<div class={'item_header' + ((isOpen) ? ' is_open' : '')}>
				<div class="item_title_container">
					<ActionLink
						onClick={() => improvedOpen(field)}
						_class={{ icon, other:'item_title cutTextOnOverflow'}}
						autotranslate={false}
					>
						{(thumb_image !== false) && (
							<img
								src={thumb_image}
								height={20}
								width={20}
								alt=""
								class="img_thumb"
							/>
						)}

						<strong>{title}</strong>
					</ActionLink>

					{(isNotEmpty(props, 'subtitle')) && (
						<p class="subtitle">{React.cloneElement(props.subtitle, { model:field})}</p>
					)}
				</div>

				<ButtonCollection>
					{props.actions && props.actions.map((action, index) => {
						let btn_props = {};
						if(action.display != undefined && !action.display(props)) return null;
						if(action.tooltip) btn_props.tooltip = action.tooltip(props);

						return (
							<ActionButton
								key={index}
								onClick={() => action.onClick(props)}
								_class={action._class != undefined ? action._class(props) : {}}
								{...btn_props}
							/>
						)
					})}

					{(!props.actions) && (
						<>
							<SquaredButton
								onClick={() => improvedOpen(field)}
								icon={(field.id === props.open) ? 'knk-hide' : 'knk-unhide'}
								aria-label="Toggle visibility"
							/>
						
							{(props.has_visibility) && (
								<ToggleButton
									squared={true}
									onClick={() => props.dispatch({ type:'TOGGLE_VISIBILITY', id:field.id })}
									active={field.status == undefined || field.status}
									icon='knk-visible'
									icon_off='knk-invisible redIcon'
									aria-label="Toggle visibility"
								/>
							)}

							{(props.can_copy) && (
								<SquaredButton
									onClick={() => props.dispatch({ type:'COPY', field })}
									icon='knk-copy'
									aria-label="Copy"
								/>
							)}
						</>
					)}
				</ButtonCollection>
			</div>

			{(isOpen && props.element != undefined) && (
				<div class="gui_item_unfoldable_options">
					{React.cloneElement(props.element, { model:field, change:change, changeMulti:changeMulti })}
				</div>
			)}
		</li>
	)
}

const DisplayList = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [state, dispatch] = useReducer((state, action) => {
		switch (action.type) {
			
			case 'SETFORM':
				return { ...state, form:action.fields };
			
			case 'TOGGLE_VISIBILITY':
				const visibility_field = 'status';

				let new_state = {...state,form:state.form.map(field=>{
					if (field.id != action.id) return field;
					return {
						...field,
						[visibility_field]: (field[visibility_field] == undefined ? false : !field[visibility_field])
					}
				})};
				return new_state;

			case 'SETOPEN':
				return { ...state, open:(action.id != state.open) ? action.id : -1 };
			
			case 'CHANGE_MULTI':
				for(var i in state.form) {
					if(state.form[i].id != action.id) continue;

					if(action.loc == undefined) {
						state.form[i] = { ...state.form[i], ...action.data };
					}
					return {...state,form:[...state.form]};
				}
				return state;

			case 'CHANGE_VALUE':
				for(var i in state.form) {
					if(state.form[i].id != action.id) continue;

					state.form[i] = { ...state.form[i], [action.k]:action.v };
					
					return {...state,form:[...state.form]};
				}
				return state;

			default:
				return state;
		}
	}, { form:props.fields, open:-1 });

	useEffect(() => {
		if(props.onChange != undefined) props.onChange(state.form);
	}, [state.form]);

	useEffect(() => {
		if(JSON.stringify(state.form) === JSON.stringify(props.fields)) {
			return;
		}
		dispatch({ type:'SETFORM', fields:props.fields });
	}, [ props.fields ]);

	let fields = [];
	if(props.fields != undefined) {
		props.field_types.map((f) => {
			fields.push({ ...f, action:() => addField(f.type) });
		});
	}

	const section_classes = props?.section_classes ?? null;

	return (
		<article class={section_classes}>
			<BuilderSubSectionTitle
				title={props?.section_title ?? "Form fields"}
				icon={props?.section_icon ?? 'knk-settings'}
				bordered={false}
				title_actions={(props.title_action != undefined) ? (
					<span>{props.title_action}</span>
				) : null}
			/>

			<ul class="gui_sortable_list gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap">
				{state.form.length > 0 && state.form.map((item, index) => {
					return (
						<Item
							key={item.id}
							index={index}
							field={item}
							open={state.open}
							onOpen={props.onOpen}
							element={props.children}
							fields={fields}
							dispatch={dispatch}
							actions={props.actions}
							subtitle={props.subtitle}
						/>
					)
				})}

				{(state.form.length < 1) && (
					<li class="gui_sortable_list_item gui_flexbox gui_flex_start gui_flex_col gui_flex_nowrap gui_flex_align_center">
						<div class="item_header">
							<div class="item_title_container gui_not_in_start_small">{i18n("There are no items")}.</div>
						</div>
					</li>
				)}
			</ul>
		</article>
	)
}
export default injectIntl(DisplayList);